import allTypes from "./mutation-types"
import lottie from "lottie-web"
import autoLayoutLoading from "assets/images/lottie/autoLayoutLoading.json"
import { Loading, Message } from "element-ui"
import publicMutations from "../publicModule/publicMutations"
import { getSyetemModuleJson } from "@/utils/initEv.js"
import menu from "../menu/state"
import { appNav_children } from "dependencies/heighLevelComByLayout/appNav"
import {
  getAllElementsInColsInLayoutComponent,
  handleFindLayoutComponentOptions,
  getAllRectInNewLayout,
  getAttrById,
  findAllRects,
  findRectPath,
  smartMathMax
} from "utils"
import { event } from "utils/event"
import appMenu from "../appMenu/state"
import Vue from "vue"
import { primaryappStagePageLayoutGenerator } from "@/store/modules/appStage/state"
import { LayoutGenerator } from "dependencies/emptyLayout/utils/layoutGenerator.js"
import { layout_title_drawer_button_children } from "materials/button/menus"
import { list_page_drawer_button_children, app_multiFilter_drawer_button_children } from "materials/button/menus"
import {
  MergeRelation,
  resetCoveredComponent,
  otherBaseComponentShape,
  appWidth,
  appPaddingLeft,
  appPaddingRight,
  xOtherContentWidth,
  appContentHeadPageLayoutHeight,
  appContentWidth,
  lockWidthComponent,
  getRectPath,
  growCurrPageLayoutH,
  toPxPosition,
  overFlowHiddenEl,
  handleChangeElementInWrapper,
  HandleSize,
  copyDataId
} from "./utils"
import { delAnimateInRect, editAnimateAddLayout } from "../../../utils/event/animate"
import { CATEGORY_MODE } from "@/consts"
let hadAppModule = {}
let allRectsOfPagelayout = [] // 临时变量，存放所有的组件
async function setAllElementInLayoutSizeAndFontSize(allColsElement, rect, containerItem, pageLayoutList) {
  //处理自由布局正文的自适应回显
  const rectEl = document.getElementsByClassName(
    event.getIdsByStrId({ container_id: containerItem.container_id, rect_id: rect.rect_id })
  )[0]
  if (!rectEl) return
  const topTitle = rect.options.titleOptions.find(it => it.type === "top")
  const bottomTitle = rect.options.titleOptions.find(it => it.type === "bottom")
  const otherComponentHeight = (topTitle.isShow ? topTitle.height : 0) + (bottomTitle.isShow ? bottomTitle.height : 0)
  for (let uid in allColsElement) {
    const _el = rectEl.getElementsByClassName("componentBox_after" + uid)[0]
    if (!_el) continue
    const { oldColWidth, oldColHeight } = allColsElement[uid].componentBoxOptions
    const elementsInCol = []
    const systemElementsInCol = []
    allColsElement[uid].elementOptions.forEach(ele => {
      if (ele.isSystemComponent) systemElementsInCol.push(ele)
      else elementsInCol.push(ele)
    })
    let { offsetWidth: currColWidth, offsetHeight: currColHeight } = _el
    //初始化组件的连通关系
    const mergeRelation = new MergeRelation(elementsInCol, oldColWidth, oldColHeight, currColWidth, currColHeight)
    for (let j = 0; j < elementsInCol.length; j++) {
      const elementInLayout = elementsInCol[j]
      deepChangeFontSize(elementInLayout) //递归的修改自由布局内单元格中的组件的fontsize
      //修改组件的百分比位置
      handleChangeElementInWrapper(elementInLayout, oldColWidth, oldColHeight, currColWidth, currColHeight)
    }
    //根据mergeRelation初始化好的联通关系，对大小位置变化后的组件进行关系还原
    mergeRelation.reMergeElements()
    try {
      // await stop(50)

      resetCoveredComponent({
        component: elementsInCol,
        basePath: null,
        wrapperW: currColWidth,
        wrapperH: currColHeight,
        mode: "x",
        resize: false
      })
      const newCurrColHeight = resetCoveredComponent({
        component: elementsInCol,
        basePath: null,
        wrapperW: currColWidth,
        wrapperH: currColHeight,
        mode: "y",
        resize: true
      })
      // currColHeight = newCurrColHeight
      //处理单元格被撑高的逻辑
      if (currColHeight < newCurrColHeight) {
        const growH = newCurrColHeight - currColHeight
        const { oldH, newH } = growCurrPageLayoutH(pageLayoutList, rect, growH)
        const newContentH = newH - otherComponentHeight
        const oldContentH = oldH - otherComponentHeight
        const useActiveIndex = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
        const rows = rect.options.rows[useActiveIndex || 0].cols[0].rows
        for (let i = 0; i < rows.length; i++) {
          const row = rows[i]
          if (row.cols.find(col => col.uid === uid)) {
            //当前变大的单元格所在的行，需要增大当前行的高度
            row.height = (newCurrColHeight / newContentH) * 100 + "%"
          } else {
            //非当前变大的单元格所在的行，需要缩小当前行的高度
            row.height = (((Number(row.height.slice(0, -1)) / 100) * oldContentH) / newContentH) * 100 + "%"
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
    delete allColsElement[uid].componentBoxOptions.oldColWidth
    delete allColsElement[uid].componentBoxOptions.oldColHeight
  }
}
function deepCheckSingleLayout(itemRow) {
  let row = [itemRow]
  while (row.length === 1 && row[0].cols.length === 1) {
    if (row[0].cols[0].rows) {
      row = row[0].cols[0].rows
    } else break
  }
  return row
}
function kindOfColSize(colsSize) {
  const sizeKinds = {}
  for (let i = 0; i < colsSize.length; i++) {
    const k = colsSize[i].colWidth + "-" + colsSize[i].colHeight
    if (!sizeKinds[k]) sizeKinds[k] = [colsSize[i]]
    else sizeKinds[k].push(colsSize[i])
  }
  return sizeKinds
}
function handleTopOptions(rect, _growCurrPageLayoutH) {
  const top = rect.options.titleOptions.find(it => it.type === "top")
  const oldHeight = top.height || xOtherContentWidth
  let newTopH = oldHeight
  try {
    newTopH = resetCoveredComponent({
      component: top.elementOptions.filter(it => it.isShow),
      basePath: "options",
      wrapperW: appContentWidth,
      wrapperH: oldHeight,
      mode: "y",
      resize: true
    })
  } catch (error) {
    console.log(error)
  }
  const growH = newTopH - oldHeight
  top.height = newTopH
  rect.options.height += growH
  _growCurrPageLayoutH(growH)
}
function handleTitleOptions(rect, oldRectW, type) {
  //将右侧的多级下拉改为点击激活
  const titleOption = rect.options.titleOptions.find(item => item.type === (type === "L" ? "left" : "right"))
  //没有显示的侧边栏不用抽屉化
  if (titleOption.isShow === false) return
  const hasBtn = rect.options.titleOptions
    .find(it => it.type === "top")
    .elementOptions.find(item => item.options.drawerPosition === type)
  rect.options["isDrawerMode" + type] = true
  // 判断当前navMenu组件是否显示
  let isShowNavMenu = true
  for (let i = 0; i < titleOption.elementOptions.length; i++) {
    if (titleOption.elementOptions[i].innerElement.includes("Menu")) {
      titleOption.elementOptions[i].options.menuTrigger = "click"
      isShowNavMenu = titleOption.elementOptions[i].options.isShow
    }
  }
  //检测自由布局头部框内是否有按钮开关，如果没有就要初始化一个
  if (hasBtn === undefined) {
    const btn = JSON.parse(JSON.stringify(layout_title_drawer_button_children[0].attribute.options))
    btn.drawerPosition = type
    btn.isCustomComponent = true
    btn.name = type === "L" ? "左侧抽屉按钮" : "右侧抽屉按钮"
    btn.top = 0
    if (type === "L") {
      btn.left = 0
    } else {
      btn.left = oldRectW - btn.width
    }
    if (btn.hasOwnProperty("pluginName") === false) btn.pluginName = ["layoutTitleOptionDrawerPlugin"]
    else btn.pluginName.push("layoutTitleOptionDrawerPlugin")
    const temp = JSON.parse(
      JSON.stringify(rect.options.titleOptions.find(it => it.type === "top").elementOptions)
    ).sort((a, b) => a.elementInLayoutId - b.elementInLayoutId)
    // 初始化之前需要先判断当前页面是否展示导航组件，不展示的话需要将控制抽屉的按钮隐藏
    const appId = GetRequest().a
    const subPage = JSON.parse(window.localStorage.getItem("subPageSetting-" + appId + "-stage"))
    const newOptions = {
      innerElement: btn.innerElement,
      isActive: subPage && subPage.listPageSetting.showNavMenu,
      isShow: isShowNavMenu,
      elementInLayoutId: temp.length > 0 ? temp[temp.length - 1].elementInLayoutId + 1 : 0,
      options: btn
    }
    rect.options.titleOptions.find(it => it.type === "top").elementOptions.push(newOptions)
  }
}
function handleTwoKindsCols(colsSizeKinds, colsSizeKindsKeys, itemRow) {
  let rowCount = 0 //统计行数 > 5行就不再转化
  let totalH = 0
  //根据单元格大小从大到小排序
  sortColsSizeKinds(colsSizeKinds, colsSizeKindsKeys)
  //先生成一个一行一列的自由布局
  const baseLayout = new LayoutGenerator({
    rows: [
      {
        height: "100%",
        cols: [
          {
            width: "100%",
            baseComponentBoxOptions: {
              bgColor: "rgba(255,255,255,0)"
            }
          }
        ]
      }
    ]
  }).rows
  Vue.set(itemRow, "cols", baseLayout[0].cols)
  //初始化行
  Vue.set(itemRow.cols[0], "rows", [])
  const colsHeight = []
  // 先处理大的单元格
  for (let i = 0; i < colsSizeKinds[colsSizeKindsKeys[0]].length; i++) {
    if (rowCount++ >= 4) break
    const { uid, colHeight, colWidth, elementOptions, componentBoxOptions } = colsSizeKinds[colsSizeKindsKeys[0]][i]
    const realColHeight = colHeight
    colsHeight.push(realColHeight)
    totalH += realColHeight
    const tempRow = new LayoutGenerator({
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions,
              componentBoxOptions
            }
          ]
        }
      ]
    }).rows[0]
    tempRow.cols[0].uid = uid
    itemRow.cols[0].rows.push(tempRow)
  }
  //再处理小单元格
  for (let i = 0; i < colsSizeKinds[colsSizeKindsKeys[1]].length; i++) {
    if (rowCount++ >= 4) break
    const { uid, colHeight, colWidth, elementOptions, componentBoxOptions } = colsSizeKinds[colsSizeKindsKeys[1]][i]
    const realColHeight = colHeight
    colsHeight.push(realColHeight)
    totalH += realColHeight
    if (i !== colsSizeKinds[colsSizeKindsKeys[1]].length - 1) {
      //剩余两个单元格以上
      const {
        uid: _uid,
        colHeight: _colHeight,
        elementOptions: _elementOptions,
        componentBoxOptions: _componentBoxOptions
      } = colsSizeKinds[colsSizeKindsKeys[1]][++i]
      const _tempRow = new LayoutGenerator({
        rows: [
          {
            height: "100%",
            cols: [
              {
                width: "50%",
                elementOptions,
                componentBoxOptions
              },
              {
                width: "50%",
                elementOptions: _elementOptions,
                componentBoxOptions: _componentBoxOptions
              }
            ]
          }
        ]
      }).rows[0]
      _tempRow.cols[0].uid = uid
      _tempRow.cols[1].uid = _uid
      itemRow.cols[0].rows.push(_tempRow)
    }
  }
  //处理每行高度
  for (let i = 0; i < itemRow.cols[0].rows.length; i++) {
    Vue.set(itemRow.cols[0].rows[i], "height", (colsHeight[i] / totalH) * 100 + "%")
  }
  return totalH
}
function handleThreeKindsCols(colsSizeKinds, colsSizeKindsKeys, itemRow) {
  let rowCount = 0 //统计行数 > 5行就不再转化
  let totalH = 0
  //根据单元格大小从大到小排序
  sortColsSizeKinds(colsSizeKinds, colsSizeKindsKeys)
  //先生成一个一行一列的自由布局
  const baseLayout = new LayoutGenerator({
    rows: [
      {
        height: "100%",
        cols: [
          {
            width: "100%",
            baseComponentBoxOptions: {
              bgColor: "rgba(255,255,255,0)"
            }
          }
        ]
      }
    ]
  }).rows
  Vue.set(itemRow, "cols", baseLayout[0].cols)
  //初始化行
  Vue.set(itemRow.cols[0], "rows", [])
  const colsHeight = []
  for (let i = 0; i < colsSizeKindsKeys.length; i++) {
    const sameSizeCols = colsSizeKinds[colsSizeKindsKeys[i]]
    for (let j = 0; j < sameSizeCols.length; j++) {
      if (rowCount++ >= 4) break
      const { uid, colHeight, colWidth, elementOptions, componentBoxOptions } = sameSizeCols[j]
      const realColHeight = colHeight
      colsHeight.push(realColHeight)
      totalH += realColHeight
      const tempRow = new LayoutGenerator({
        rows: [
          {
            height: "100%",
            cols: [
              {
                width: "100%",
                elementOptions,
                componentBoxOptions
              }
            ]
          }
        ]
      }).rows[0]
      tempRow.cols[0].uid = uid
      itemRow.cols[0].rows.push(tempRow)
    }
  }
  //处理每行高度
  for (let i = 0; i < itemRow.cols[0].rows.length; i++) {
    Vue.set(itemRow.cols[0].rows[i], "height", (colsHeight[i] / totalH) * 100 + "%")
  }
  return totalH
}
function sortColsSizeKinds(colsSizeKinds, colsSizeKindsKeys) {
  colsSizeKindsKeys.sort(
    (a, b) =>
      colsSizeKinds[b][0].colHeight * colsSizeKinds[b][0].colWidth -
      colsSizeKinds[a][0].colHeight * colsSizeKinds[a][0].colWidth
  )
}
function setOtherContentSize(layoutRect, oldRectW, oldRectH, merges) {
  const { titleOptions } = layoutRect.options
  const newRectW = appContentWidth
  const newRectH = oldRectH
  //上下框的高度合
  let TopAndBottomH = 0
  for (let i = 0; i < titleOptions.length; i++) {
    if (titleOptions[i].type === "top" || titleOptions[i].type === "bottom")
      TopAndBottomH += titleOptions[i].isShow
        ? titleOptions[i].hasOwnProperty("height")
          ? titleOptions[i].height
          : xOtherContentWidth
        : 0
  }
  for (let i = 0; i < titleOptions.length; i++) {
    if (!titleOptions[i].isShow) continue
    //是否是左右两边的框
    const isX = titleOptions[i].type === "left" || titleOptions[i].type === "right"
    const currWrapperEle = titleOptions[i].elementOptions
    const oldWrapperWidth = isX ? titleOptions[i].width || xOtherContentWidth : oldRectW
    const oldWrapperHeight = isX ? oldRectH - TopAndBottomH : titleOptions[i].height
    const newWrapperWidth = isX ? titleOptions[i].width || xOtherContentWidth : newRectW
    const newWrapperHeight = oldWrapperHeight
    //由于自由布局自适应前后组件高度不变 所以新老上下框的计算方式不变
    for (let j = 0; j < currWrapperEle.length; j++) {
      const rect = currWrapperEle[j]
      if (rect?.options) {
        handleChangeElementInWrapper(rect.options, oldWrapperWidth, oldWrapperHeight, newWrapperWidth, newWrapperHeight)
      }
    }
    merges[titleOptions[i].type] && merges[titleOptions[i].type].reMergeElements()
    try {
      resetCoveredComponent({
        component: currWrapperEle.filter(it => it.isShow !== false),
        basePath: "options",
        wrapperW: newRectW,
        wrapperH: newRectH,
        mode: "x",
        resize: false
      })
    } catch (error) {
      console.log(error)
    }
  }
}
function calcLayout(contentRow, oldRectW, oldRectH) {
  const allColsElement = getAllElementsInColsInLayoutComponent(contentRow)
  let itemColLen = null //变换前 单行中 有多少个列
  let lockNum = null // 变换后 单行多少个列
  let num = 0 //计数器 等于零时进行一次行的初始化
  let tempRow = null
  let rowHeight = null
  let maxRowLen = null
  for (let uid in allColsElement) {
    const { elementOptions, componentBoxOptions } = allColsElement[uid]
    if (itemColLen === null) {
      //对单个行中 需要多少个列的数量 进行初始化
      itemColLen = Math.round(oldRectW / componentBoxOptions.oldColWidth)
      rowHeight = (componentBoxOptions.oldColHeight / oldRectH) * 100 + "%"
      maxRowLen = Math.round(oldRectH / componentBoxOptions.oldColHeight)
      lockNum = itemColLen > 3 ? 2 : 1 //单行数量大于3就缩减为2列，否则就是一列撑满
      //当自由布局组件宽度小于400且单行数量需要缩减成1列的场景下，就保持原来的列数
      if (lockNum === 1 && oldRectW <= 400) {
        lockNum = itemColLen
      }
      while (contentRow.length) contentRow.pop() //将之前的单元格归零
    }
    if (num === 0) {
      if (maxRowLen === 0) break
      maxRowLen--
      tempRow = new LayoutGenerator({
        rows: [
          {
            height: rowHeight,
            cols: [
              {
                width: itemColLen > 3 ? "50%" : "100%",
                elementOptions,
                componentBoxOptions
              }
            ]
          }
        ]
      }).rows[0]
      contentRow.push(tempRow)
      tempRow.cols[0].uid = uid
      num = lockNum
    } else {
      tempRow.cols.push(JSON.parse(JSON.stringify(tempRow.cols[tempRow.cols.length - 1])))
      tempRow.cols[tempRow.cols.length - 1].uid = uid
      tempRow.cols[tempRow.cols.length - 1].elementOptions = elementOptions
      tempRow.cols[tempRow.cols.length - 1].componentBoxOptions = componentBoxOptions
    }
    num--
  }
}
function handleFixSwiper(rect, rectEl) {
  const { offsetWidth: width, offsetHeight: height } = rectEl.isNativeObj
    ? rectEl
    : rectEl.getElementsByClassName("swiper-wrapper")[0]
  rect.options.content.forEach(contentItem => {
    contentItem.elementOptions.forEach(elementInSwiper => {
      deepChangeFontSize(elementInSwiper)
      //根据比例修改宽高
      if (elementInSwiper.widthType !== "%" && !lockWidthComponent(elementInSwiper.innerElement)) {
        elementInSwiper.width = elementInSwiper.percentW * width
      }
      // 根据比例修改位置
      if (elementInSwiper.leftType !== "%") {
        elementInSwiper.left = width * elementInSwiper.percentL
      }
      elementInSwiper.top = height * elementInSwiper.percentT
      delete elementInSwiper.percentL
      delete elementInSwiper.percentW
      delete elementInSwiper.percentT
      //文本组件溢出隐藏
      if (overFlowHiddenEl(elementInSwiper.innerElement)) {
        elementInSwiper.textOverFlowType = "hidden"
      }
    })
    try {
      resetCoveredComponent({
        component: contentItem.elementOptions,
        basePath: null,
        wrapperW: width,
        wrapperH: height,
        mode: "x",
        resize: false
      })
    } catch (error) {
      console.log(error)
    }
  })
}
function fixFontSize(ft) {
  if (ft === 12 || ft === 13 || ft === 14) return 12
  else if (ft > 14 && ft < 30) return ft - 2
  else if (ft >= 30) return ft - 4
  return ft
}
function checkLayoutColSize(ItemRow, rect, containerItem) {
  const allColsElement = getAllElementsInColsInLayoutComponent([ItemRow]) //获取当前row里的所有cols的uid
  const colsSize = getAllColsSize(allColsElement, rect, containerItem) //获取所有cols的大小，以{uid:xxx, width: xxx, height: xxx}的形式返回
  return [checkSize(colsSize), colsSize, allColsElement] //检查所有数据的大小是否一致
}
function checkSize(colsSize) {
  return colsSize.every((item, index, array) => {
    const prevIndex = index - 1
    if (index === 0) return true
    return (
      Math.max(item.colWidth, array[prevIndex].colWidth) - Math.min(item.colWidth, array[prevIndex].colWidth) <= 5 &&
      Math.max(item.colHeight, array[prevIndex].colHeight) - Math.min(item.colHeight, array[prevIndex].colHeight) <= 5
    )
  })
}
function getAllColsSize(allColsElement, rect, containerItem) {
  const result = []
  // const rectEl = document.getElementsByClassName(
  //   event.getIdsByStrId({ container_id: containerItem.container_id, rect_id: rect.rect_id })
  // )[0]
  // if (rectEl) {
  for (let uid in allColsElement) {
    // const _el = rectEl.getElementsByClassName("componentBox_after" + uid)[0].parentNode.parentNode
    // if (!_el) continue
    // const width = _el.offsetWidth
    // const Height = _el.offsetHeight
    result.push({
      uid,
      componentBoxOptions: allColsElement[uid].componentBoxOptions,
      elementOptions: allColsElement[uid].elementOptions,
      colWidth: allColsElement[uid].componentBoxOptions.oldColWidth,
      colHeight: allColsElement[uid].componentBoxOptions.oldColHeight
    })
  }
  // }
  return result
}
function checkRowSize(contentRow) {
  if (contentRow.length === 1 && contentRow[0].cols.length === 1) return false
  const baseColLen = contentRow[0].cols.length
  const isSameColLen = contentRow.every(itRow => itRow.cols.length === baseColLen)
  return isSameColLen ? baseColLen : false
}
async function setLayoutPercentPosition(rect, rectW, rectH, containerItem, deep = 0) {
  //处理自由布局内容区域逻辑
  for (let k in rect.options) {
    //将padding缩小一半
    if (k.includes("padding")) {
      Vue.set(rect.options, k, Number(rect.options[k]) / 2)
    }
  }
  const rectEl = document.getElementsByClassName(
    event.getIdsByStrId({ container_id: containerItem.container_id, rect_id: rect.rect_id })
  )[0]
  if (!rectEl) return
  const useActiveIndex = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
  const itemRow = rect.options.rows[useActiveIndex]
  const allColsElement = getAllElementsInColsInLayoutComponent([itemRow]) //获取当前row里的所有cols
  for (let uid in allColsElement) {
    const col = allColsElement[uid]
    for (let k in col.componentBoxOptions) {
      if (k.includes("padding") && isNaN(col.componentBoxOptions[k]) === false) {
        Vue.set(col.componentBoxOptions, k, col.componentBoxOptions[k] / 2)
      }
    }
    const _el = rectEl.getElementsByClassName("componentBox_after" + uid)[0]
    if (!_el) {
      if (deep < 20) {
        //当前单元格dom不存在 可能是因为改了自由布局的配置项，导致出发了自由布局组件里的reload方法，这时dom就不存在
        //等待100ms的dom渲染，最大等待时长不超过2000ms
        await stop(100)
        await setLayoutPercentPosition(rect, rectW, rectH, containerItem, deep + 1)
      }
      return
    }
    //通过getComputedStyle提前出发dom渲染
    window.getComputedStyle(_el)
    const width = _el.parentNode.parentNode.offsetWidth
    const height = _el.parentNode.parentNode.offsetHeight
    col.componentBoxOptions.oldColWidth = width
    col.componentBoxOptions.oldColHeight = height
    const allElementInLayout = handleFindLayoutComponentOptions(rect.options.rows, uid)

    for (let j = 0; j < allElementInLayout.length; j++) {
      const elementInLayout = allElementInLayout[j]
      //组件真实位置
      toPxPosition(elementInLayout, { boundWidth: width, boundHeight: height })
    }
  }
  //处理自由布局上下左右四个区域逻辑
  const { titleOptions } = rect.options
  for (let i = 0; i < titleOptions.length; i++) {
    const currWrapperEle = titleOptions[i].elementOptions
    //是否上下框
    const isTB = titleOptions[i].type === "top" || titleOptions[i].type === "bottom"
    const topRect = titleOptions.find(it => it.type === "top")
    const bottomRect = titleOptions.find(it => it.type === "bottom")
    const pW = isTB ? rectW : titleOptions[i].width || 200
    const pH = isTB
      ? titleOptions[i].height || xOtherContentWidth
      : rectH -
        (topRect.isShow ? topRect.height || xOtherContentWidth : 0) -
        (bottomRect.isShow ? bottomRect.height || xOtherContentWidth : 0)
    for (let j = 0; j < currWrapperEle.length; j++) {
      if (currWrapperEle[j]?.options) {
        const { width, left: cL, widthType } = currWrapperEle[j].options
        const cW = widthType === "%" ? (pW * Number(width)) / 100 : width
        currWrapperEle[j].options.percentW = cW / pW
        currWrapperEle[j].options.percentL = cL / pW
        //组件真实位置
        toPxPosition(currWrapperEle[j].options, { boundWidth: pW, boundHeight: pH })
      }
    }
  }
}
function setSwiperPercentPosition(rect, rectEl) {
  const { offsetWidth: width, offsetHeight: height } = rectEl.isNativeObj
    ? rectEl
    : rectEl.getElementsByClassName("componentBox")[0]
  rect.options.content.forEach(content => {
    content.elementOptions.forEach(elementInSwiper => {
      //宽高处理
      if (elementInSwiper.widthType === "%") {
        elementInSwiper.percentW = elementInSwiper.width / 100
      } else {
        elementInSwiper.percentW = elementInSwiper.width / width
      }

      //位置处理
      if (elementInSwiper.leftType === "%") {
        elementInSwiper.percentL = elementInSwiper.left / 100
      } else {
        elementInSwiper.percentL = elementInSwiper.left / width
      }
      elementInSwiper.percentT = elementInSwiper.top / height
    })
  })
  // 处理特殊样式的轮播页宽高
  if (rect.options.slideHeight && rect.options.slideHeight) {
    rect.options.slideWidth = 130
    rect.options.slideHeight = 200
  }
}
function deepChangeFontSize(org) {
  dfs(org)
  function dfs(org) {
    for (let k in org) {
      if (typeof org[k] === "object") {
        dfs(org[k])
      } else if (k.toLowerCase().includes("fontsize") && isNaN(org[k]) === false) {
        org[k] = fixFontSize(Number(org[k]))
      }
    }
  }
}
//获取所有基础组件的shape
function getBaseComponentShape() {
  return menu.menu.children
    .find(it => it.type === "baseElement")
    .children.map(it => it.type)
    .concat(otherBaseComponentShape)
}
/**
 * 特殊处理头部下拉框组件,这里是使用的预设好的一个 基于自由布局组件+插件的组件
 */
function headContainerNav(rect, isNewLayout) {
  const oldRectOpt = rect.options
  rect.options = JSON.parse(JSON.stringify(appNav_children[0].attribute.options))
  rect.options.rows[0].cols[0].elementOptions.find(ele => ele.innerElement === "cxButton").iconWidth = 24
  rect.options.rows[0].cols[0].elementOptions.find(ele => ele.innerElement === "cxButton").left = 5
  const nav = rect.options.rows[0].cols[0].elementOptions.find(ele => ele.innerElement === "cxNavMenuVertical")
  nav.selectOptions = oldRectOpt.selectOptions
  copyDataId(oldRectOpt, nav)
  nav.top += 10
  rect.shape = "emptyLayoutComponent"
  if (isNewLayout) {
    rect.options.width = (appWidth - appPaddingLeft) / 3
    // rect.options.left = -20
    rect.options.top = 0
    rect.options.rows[0].cols[0].elementOptions.forEach(it => (it.top += 15))
    // 把导航菜单的appId同步到自由布局上 否则找不到子页面映射关系
    rect.options.appId = nav.appId
  }
  return rect
}
function headContainerLogo(rect, isNewLayout) {
  // image_children
  const newW = (36 / rect.options.height) * rect.options.width
  if (newW > 280) {
    rect.options.height *= 280 / rect.options.width
    rect.options.width = 280
  } else {
    rect.options.height *= newW / rect.options.width
    rect.options.width = newW
  }
  rect.options.widthType = "px"
  rect.options.heightType = "px"
  rect.options.top = isNewLayout ? (appContentHeadPageLayoutHeight - rect.options.height) / 2 : 13.6
  rect.options.left = 147 - (isNewLayout ? appWidth / 3 : 0)
  return rect
}
/**特殊处理登陆组件,需要把登陆组件中 登录按钮和登陆图片的样式 改成移动端的风格 */
function headContainerLogin(rect, isNewLayout) {
  const beforeLoginRow = rect.options.rows[0].cols[0].elementOptions
  const afterLoginRow = rect.options.rows[1].cols[0].elementOptions
  rect.options.width = 32
  rect.options.height = 32
  rect.options.left = isNewLayout ? 0 : 367
  rect.options.top = isNewLayout ? 0 : 15
  rect.options.widthType = "px"
  rect.options.heightType = "px"
  for (let i = 0; i < beforeLoginRow.length; i++) {
    if (beforeLoginRow[i].loginType === "loginBtn") {
      beforeLoginRow[i].width = 24
      beforeLoginRow[i].height = 24
      beforeLoginRow[i].left = 4
      beforeLoginRow[i].top = 4 + (isNewLayout ? 15 : 0)
      beforeLoginRow[i].iconWidth = 24
      beforeLoginRow[i].iconMargin = 0
      beforeLoginRow[i].widthType = "px"
      beforeLoginRow[i].heightType = "px"
      beforeLoginRow[i].content = ""
      beforeLoginRow[i].iconColor = "rgba(0, 0, 0, 0.8)"
      beforeLoginRow[i].bgColor = "rgba(0, 0, 0, 0.0)"
      beforeLoginRow[i].borderColor = "rgba(0, 0, 0, 0.0)"
    }
  }
  for (let i = 0; i < afterLoginRow.length; i++) {
    if (afterLoginRow[i].loginType === "loginImage") {
      afterLoginRow[i].width = 32
      afterLoginRow[i].height = 32
      afterLoginRow[i].widthType = "px"
      afterLoginRow[i].heightType = "px"
      afterLoginRow[i].left = 0
      afterLoginRow[i].top = 0 + (isNewLayout ? 11 : 0)
    }
    if (afterLoginRow[i].loginType === "loginName") {
      afterLoginRow[i].width = 32
      afterLoginRow[i].height = 32
      afterLoginRow[i].opacity = 100
      afterLoginRow[i].menuOpacity = 0
      afterLoginRow[i].left = 0
      afterLoginRow[i].top = 0 + (isNewLayout ? 11 : 0)
    }
  }
  resetComponentTypeId(rect.options, rect.shape)
  return rect
}
function getContainerItem(state) {
  return state.page.children.find(it => it.options.inDocument !== "footer" && it.options.inDocument !== "header")
}
function getRectOpt(containerItem, rect_id) {
  return containerItem.children.find(rect => rect.rect_id === rect_id)
}
function handleWaterHeadLayout(container, headLayout, dataType) {
  const headLayoutOpt = headLayout.options
  //headComponentMap内存储了在pc端打好标记的需要做移动端自适应的组件的rect_id
  const { headComponentMap } = headLayout.options
  const primaryAppLayoutStage = new primaryappStagePageLayoutGenerator(1)
  //拷贝原来的顶部通栏的样式
  primaryAppLayoutStage.id = 0
  primaryAppLayoutStage.layout.rows[0].options.height = appContentHeadPageLayoutHeight
  primaryAppLayoutStage.layout.rows[0].options.waterFlow = true
  primaryAppLayoutStage.layout.rows[0].options.isNewVersion = true
  primaryAppLayoutStage.layout.rows[0].options.waterFlowMargin = [0, 10]
  primaryAppLayoutStage.layout.rows[0].rectIds = headLayout.layout.rows[0].rectIds
  primaryAppLayoutStage.options = JSON.parse(JSON.stringify(headLayoutOpt))
  primaryAppLayoutStage.options.height = 54
  primaryAppLayoutStage.options.padding[0] = headLayoutOpt.padding[0] / 2 || 0
  primaryAppLayoutStage.options.padding[1] = 0
  primaryAppLayoutStage.options.padding[2] = headLayoutOpt.padding[2] / 2 || 0
  primaryAppLayoutStage.options.padding[3] = 0
  if (headComponentMap) primaryAppLayoutStage.options.headComponentMap = { ...headComponentMap }
  primaryAppLayoutStage.options.inDocument = "header"
  //初始化定制的头部通栏样式
  // const appHeaderLayoutColLen = 3
  // for (let i = 0; i < appHeaderLayoutColLen; i++) {
  //   let layout = new primaryappStagePageLayoutGenerator()
  //   let newCol = layout.layout.rows[0]
  //   newCol.options.height = primaryAppLayoutStage.options.height
  //   newCol.id = i
  //   primaryAppLayoutStage.layout.rows[0].layout.cols.push(newCol)
  // }
  // primaryAppLayoutStage.layout.rows[0].layout.cols[0].options.width = "81%" //logo
  // primaryAppLayoutStage.layout.rows[0].layout.cols[1].options.width = "9%" //登录框
  // primaryAppLayoutStage.layout.rows[0].layout.cols[2].options.width = "10%" //多级下拉
  //这里开始处理组件的配置项
  const gridLayout = []
  for (let k in headComponentMap || {}) {
    if (k === "nav" && typeof headComponentMap[k] === "number") {
      try {
        //特殊处理头部画布的导航组件
        const rect = findRectPath(container.children, "nav", headComponentMap[k], true)
        rect && headContainerNav(rect, true)
        gridLayout.push({
          i: rect.i,
          x: 42,
          y: 0,
          w: 4,
          h:50,
          moved: false
        })
      } catch (error) {
        console.error(error)
      }
    } else if (k === "logo" && typeof headComponentMap[k] === "number") {
      try {
        const rect = findRectPath(container.children, "logo", headComponentMap[k], true)
        //特殊处理头部画布的logo组件
        rect && headContainerLogo(rect, true)
        gridLayout.push({
          i: rect.i,
          x: 0,
          y: 0,
          w: 28,
          h:50,
          moved: false
        })
      } catch (error) {
        console.log(error)
      }
    } else if (k === "login" && typeof headComponentMap[k] === "number") {
      try {
        const rect = findRectPath(container.children, "login", headComponentMap[k], true)
        //特殊处理头部画布的登录组件
        rect && headContainerLogin(rect, true)
        gridLayout.push({
          i: rect.i,
          x: 38,
          y: 0,
          w: 4,
          h:50,
          moved: false
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  primaryAppLayoutStage.layout.rows[0].options.gridLayout = gridLayout
  try {
    //拿到头部通栏所有组件的rect_id
    let allRectId = getAllRectInNewLayout([headLayout])
      .map(it => it.rects || [])
      .flat(1)
    allRectId = [...new Set(allRectId)]
    //过滤掉头部绑定的组件 剩下的组件没用 需要删掉
    Object.values(headComponentMap || {})
      .filter(it => typeof it === "number")
      .forEach(saveRectId => {
        allRectId.splice(
          allRectId.findIndex(it => it === saveRectId),
          1
        )
      })
    //在container中删除剩余组件
    allRectId.forEach(rect_id => {
      container.children.splice(
        container.children.findIndex(rect => rect.rect_id === rect_id),
        1
      )
    })
  } catch (error) {
    console.log(error)
  }
  return primaryAppLayoutStage
}
function handleHeadLayout(container, headLayout, dataType) {
  const headLayoutOpt = headLayout.options
  //headComponentMap内存储了在pc端打好标记的需要做移动端自适应的组件的rect_id
  const { headComponentMap } = headLayout.options
  const primaryAppLayoutStage = new primaryappStagePageLayoutGenerator(1)
  //拷贝原来的顶部通栏的样式
  primaryAppLayoutStage.id = 0
  primaryAppLayoutStage.layout.rows[0].options.height = appContentHeadPageLayoutHeight
  primaryAppLayoutStage.options = JSON.parse(JSON.stringify(headLayoutOpt))
  primaryAppLayoutStage.options.height = 54
  primaryAppLayoutStage.options.padding[0] = headLayoutOpt.padding[0] / 2 || 0
  primaryAppLayoutStage.options.padding[1] = 0
  primaryAppLayoutStage.options.padding[2] = headLayoutOpt.padding[2] / 2 || 0
  primaryAppLayoutStage.options.padding[3] = 0
  const allRectValInNewLayout = Object.values(getAllRectInNewLayout([headLayout]))
  if (headComponentMap) primaryAppLayoutStage.options.headComponentMap = { ...headComponentMap }
  primaryAppLayoutStage.options.inDocument = "header"
  //初始化定制的头部通栏样式
  const appHeaderLayoutColLen = 3
  for (let i = 0; i < appHeaderLayoutColLen; i++) {
    let layout = new primaryappStagePageLayoutGenerator()
    let newCol = layout.layout.rows[0]
    newCol.options.height = primaryAppLayoutStage.options.height
    newCol.id = i
    primaryAppLayoutStage.layout.rows[0].layout.cols.push(newCol)
  }
  primaryAppLayoutStage.layout.rows[0].layout.cols[0].options.width = "81%" //logo
  primaryAppLayoutStage.layout.rows[0].layout.cols[1].options.width = "9%" //登录框
  primaryAppLayoutStage.layout.rows[0].layout.cols[2].options.width = "10%" //多级下拉
  const getBg = rectId => {
    const res = allRectValInNewLayout.find(it => it.rects.find(rect_id => rect_id == rectId) !== undefined)
    if (res) {
      return JSON.parse(JSON.stringify(res.options.bg))
    } else return null
  }
  //  rects: rectsId, size, options
  //有headComponentMap,说明有需要做移动端自适应的组件
  //这里主要是把对应组件塞入到移动端的对应布局中
  if (headComponentMap) {
    if (typeof headComponentMap.nav === "number") {
      //同步当前组件在pc端所在布局的背景色
      const bg = getBg(headComponentMap.nav)
      if (bg) {
        primaryAppLayoutStage.layout.rows[0].layout.cols[2].rectIds = [headComponentMap.nav]
        primaryAppLayoutStage.layout.rows[0].layout.cols[2].options.bg = bg
      }
    } else primaryAppLayoutStage.layout.rows[0].layout.cols[2].rectIds = []
    if (typeof headComponentMap.logo === "number") {
      const bg = getBg(headComponentMap.logo)
      if (bg) {
        primaryAppLayoutStage.layout.rows[0].layout.cols[0].rectIds = [headComponentMap.logo]
        primaryAppLayoutStage.layout.rows[0].layout.cols[0].options.bg = bg
      }
    } else primaryAppLayoutStage.layout.rows[0].layout.cols[0].rectIds = []
    if (typeof headComponentMap.login === "number") {
      const bg = getBg(headComponentMap.login)
      if (bg) {
        primaryAppLayoutStage.layout.rows[0].layout.cols[1].rectIds = [headComponentMap.login]
        primaryAppLayoutStage.layout.rows[0].layout.cols[1].options.bg = bg
      }
    } else primaryAppLayoutStage.layout.rows[0].layout.cols[1].rectIds = []
  }
  //这里开始处理组件的配置项
  for (let k in headComponentMap || {}) {
    if (k === "nav" && typeof headComponentMap[k] === "number") {
      try {
        //特殊处理头部画布的导航组件
        const rect = findRectPath(container.children, "nav", headComponentMap[k], true)
        rect && headContainerNav(rect, true)
      } catch (error) {
        console.error(error)
      }
    } else if (k === "logo" && typeof headComponentMap[k] === "number") {
      try {
        const rect = findRectPath(container.children, "logo", headComponentMap[k], true)
        //特殊处理头部画布的logo组件
        rect && headContainerLogo(rect, true)
      } catch (error) {
        console.log(error)
      }
    } else if (k === "login" && typeof headComponentMap[k] === "number") {
      try {
        const rect = findRectPath(container.children, "login", headComponentMap[k], true)
        //特殊处理头部画布的登录组件
        rect && headContainerLogin(rect, true)
      } catch (error) {
        console.log(error)
      }
    }
  }
  try {
    //拿到头部通栏所有组件的rect_id
    const allRectId = getAllRectInNewLayout([headLayout])
      .map(it => it.rects || [])
      .flat(1)
    //过滤掉头部绑定的组件 剩下的组件没用 需要删掉
    Object.values(headComponentMap || {})
      .filter(it => typeof it === "number")
      .forEach(saveRectId => {
        allRectId.splice(
          allRectId.findIndex(it => it === saveRectId),
          1
        )
      })
    //在container中删除剩余组件
    allRectId.forEach(rect_id => {
      container.children.splice(
        container.children.findIndex(rect => rect.rect_id === rect_id),
        1
      )
    })
  } catch (error) {
    console.log(error)
  }
  return primaryAppLayoutStage
}
/**
 * 对于新通栏页面 进行自适应处理
 * @param {object} state 移动端当前的样式
 * @param {object} data 需要用来做自适应的数据
 * @param {Array} baseComponentShape 基础组件数组
 */
async function newLayoutAutoSize(state, data, baseComponentShape) {
  const t1 = new Date().getTime()
  console.time()
  hadAppModule = {} //初始化收藏组件options表
  let pageLayoutList = []
  state.page.pageWidth = appWidth
  let oldAllRectInLayout, _pageLayoutList, headerLayout
  let curIndex
  // 分为三种情况 1. 整个页面同步 2.某个通栏新增 3.某个通栏替换
  if (!data.type) {
    Vue.delete(state.page, "pageLayoutType")
    Vue.delete(state.page, "pageLayoutList")
    await stop(100)
    _pageLayoutList = data.data.page.pageLayoutList.filter(item => item?.options?.inDocument !== "anchor")
    //先把把头部通栏的内容取出来,用于后面的头部特殊处理
    headerLayout = _pageLayoutList[0].options.inDocument === "header" ? _pageLayoutList[0] : null
    const isWaterHead = headerLayout?.layout?.rows[0]?.options?.waterFlow
    if (headerLayout) {
      //特殊处理头部画布
      try {
        const newHeadLayout = isWaterHead ? handleWaterHeadLayout(state.page.children[0], headerLayout) : handleHeadLayout(state.page.children[0], headerLayout)
        pageLayoutList.push(newHeadLayout)
      } catch (error) {
        headerLayout = null
        console.log(error)
      }
    }
    oldAllRectInLayout = _pageLayoutList.slice(headerLayout ? 1 : 0)
  } else if (data.type === "edit") {
    let oldPageLayoutLists = state.page.pageLayoutList
    if (!oldPageLayoutLists) {
      // 预览页不是布局模式，则提示当前需要先整体同步
      return
    }
    curIndex = oldPageLayoutLists.findIndex(pageLayoutItem => pageLayoutItem.id === data.newPageLayout.id)
    if (curIndex > -1) {
      // 删除原有组件
      deleteOldRect(state.page.pageLayoutList[curIndex], state)
      oldPageLayoutLists.splice(curIndex, 1)
      Vue.set(state.page, "pageLayoutList", oldPageLayoutLists)
    }
    pageLayoutList = state.page.pageLayoutList
    oldAllRectInLayout = [data.newPageLayout]
    // 子页面关系处理
    subPagesRelationHandle(state, data, "edit")
  } else if (data.type === "new") {
    pageLayoutList = state.page.pageLayoutList
    oldAllRectInLayout = [data.newPageLayout]
    // 子页面关系处理
    subPagesRelationHandle(state, data, "new")
  }
  // if (footerLayout) {
  //   try {
  //     footerLayout = pageLayoutList.push(handleFootLayout(state.page.children[0], footerLayout))
  //   } catch (error) {
  //     _pageLayoutList.push(footerLayout)
  //     console.log(error)
  //   }
  // }

  //根据布局 获取布局中的所有组件
  let allRectInNewLayout = getAllRectInNewLayout(oldAllRectInLayout)
  // 局部同步需要提前处理 rectId
  // 新增模式直接追加rectId  替换模式需要先将被替换中的rect全部清除，然后再追加rectId, 问题：之前的不同通栏间的动画会被删除掉
  let rectIdRelation = {}
  if (data.type) {
    let replacedRectIds = replaceRectIds(state, allRectInNewLayout, data)
    allRectInNewLayout = replacedRectIds.allRectInNewLayout
    rectIdRelation = replacedRectIds.rectIdRelation
  }

  if (data.type === "edit") {
    // 只同步头部 特殊处理头部画布
    // 先判断移动端是否有头部，有则先删掉头部通栏以及通栏内的组件，再将新的组件更新rectId后同步到移动端
    // state 删除掉当前的通栏
    // todo此处还不完善 需要修改
    _pageLayoutList = data.newPageLayout
    //先把把头部通栏的内容取出来,用于后面的头部特殊处理
    headerLayout = _pageLayoutList.options.inDocument === "header" ? _pageLayoutList : null
    if (headerLayout) {
      try {
        headerReplaceRectIds(rectIdRelation, headerLayout, state, data)
        // 替换掉旧的rectId
        const isWaterHead = headerLayout?.layout?.rows[0]?.options?.waterFlow
        let newHeadLayout = isWaterHead ? handleWaterHeadLayout(state.page.children[0], headerLayout) : handleHeadLayout(state.page.children[0], headerLayout, data.type)
        if (state.page.pageLayoutList[0].options.inDocument === "header") {
          // 删除原有组件 -- 重复删除了，所以先注释
          // deleteOldRect(state.page.pageLayoutList[0],state)
          state.page.pageLayoutList.splice(0, 1, newHeadLayout)
        } else {
          state.page.pageLayoutList.splice(0, 0, newHeadLayout)
        }
      } catch (error) {
        headerLayout = null
        console.log(error)
      }
      return
    }
  }
  //装有组件的画布
  const containerItem = getContainerItem(state)
  //这里双重循环的目的是:
  //外层循环 循环一次 就会往pageLayoutList里加入一个通栏
  //内层循环负责往外层循环提供的通栏内塞入布局
  console.log('oldAllRectInLayout', oldAllRectInLayout)
  for (let i = 0; i < oldAllRectInLayout.length; i++) {
    const _layout = oldAllRectInLayout[i]
    const firstRow = _layout?.layout?.rows[0]
    const isWaterFall = firstRow?.options?.waterFlow
    const gridLayout = firstRow?.options?.gridLayout
    if (oldAllRectInLayout[i].options.isShowTabs && !oldAllRectInLayout[i].options.isShowVerticalTabs) {
      // 横向标签布局处理 每一行的第一个单元格设为true
      oldAllRectInLayout[i] = setTabRowStart(oldAllRectInLayout[i])
    }
    if (oldAllRectInLayout[i].options.isShowVerticalTabs) {
      // 横向标签布局处理 每一行的第一个单元格设为true
      oldAllRectInLayout[i] = setTabColStart(oldAllRectInLayout[i])
    }
    const currRectInLayout = getAllRectInNewLayout([oldAllRectInLayout[i]])
    let isFooter = oldAllRectInLayout[i].options?.inDocument === "footer"
    let tempLayout = null //外层循环提供的通栏,默认为null
    //通栏是否设置解绑移动端样式
    let layoutUnboundApp = oldAllRectInLayout[i].options?.unboundApp
    if(layoutUnboundApp == undefined){
      layoutUnboundApp = true
    }
    for (let i = 0; i < currRectInLayout.length; i++) {
      const { rects: rectsId, size, options } = currRectInLayout[i]
      //这里的循环是处理同一个布局内的多个个组件
      //主要是针对自由布局组件和轮播组件做预处理,
      //获取自由布局组件的单元格和轮播组件的轮播页在pc端的宽高及其内部组件的宽高所占当前容器的比例
      for (let j = 0; j < rectsId.length; j++) {
        let curRectId = data.type ? rectIdRelation[rectsId[j]] : rectsId[j]
        let rect = getRectOpt(containerItem, curRectId)
        //当rect找不到时 说明是脏数据 就跳过此次循环
        if (rect === undefined) continue
        toPxPosition(rect.options, size)
        const shape = rect.shape || rect?.options?.innerElement || ''
        const lowerInnerElement = shape.toLowerCase()
        //轮播和自由布局组件需要还原为原来的大小，并设置好在原大小内，内部组件的大小比例
        if (lowerInnerElement.includes("swiper") || (lowerInnerElement.includes("layout") && !lowerInnerElement.includes("auto"))) {
          try {
            if (rect.options.encId && layoutUnboundApp) {
              const appModule = await getSyetemModuleJson(rect.options.encId, true)
              //如果有appModule,证明当前组件在移动端有对应的移动端样式
              if (appModule) {
                // 如果PC样式有isSystemComponent标识, 移动端没得，则可能移动端是从零搭建的自由布局样式，手动赋值一下
                if (rect?.options?.isSystemComponent !== undefined) {
                  appModule.options.isSystemComponent = rect?.options?.isSystemComponent
                }
                if (rect?.options?.isIndependenceComponent !== undefined) {
                  appModule.options.isIndependenceComponent = rect?.options?.isIndependenceComponent
                }
                hadAppModule[rect.rect_id] = appModule
                //否则就走js计算逻辑
              } else await setSwiperAndLayoutPercentNumber(rect, lowerInnerElement, size, containerItem, true)
            } else await setSwiperAndLayoutPercentNumber(rect, lowerInnerElement, size, containerItem, true)
          } catch (error) {
            console.error(error)
            try{
              await setSwiperAndLayoutPercentNumber(rect, lowerInnerElement, size, containerItem, true)
            }catch (error){
              console.error(error)
            }
          }
        }

        //多级筛选加个通栏
        if (lowerInnerElement.includes("cxmultifilter")) {
          pageLayoutList.push(handleMultiFilterLayout(state, containerItem, rect))
          console.log("rect=", rect)
          rect.options.indrawer = true
        }
        // 同步表格筛选替换掉时间选择器里的relativeComponentId
        if (lowerInnerElement.includes("cxdatepicker") && rect.options?.relativeComponentId) {
          const rectId = rect.options.relativeComponentId?.rect_id
          rectId && rectIdRelation[rectId] ? rect.options.relativeComponentId.rect_id = rectIdRelation[rectId] : ""
        }
      }

      // 替换掉对用的组件rectId
      if (data.type) {
        rectsId.forEach((item, index) => {
          rectsId[index] = rectIdRelation[item]
        })
      }
      //开始将组件塞入新通栏中
      try {
        //如果外层循环提供的通栏为null,则在这里使用initMobileLayout初始化通栏,反之则往tempLayout通栏内push布局
        if (tempLayout) {
          const temp = !isWaterFall ? initMobileLayout(
            state,
            containerItem,
            rectsId,
            size,
            options,
            baseComponentShape,
            tempLayout.layout.rows.length,
            isFooter
          ) : initGridMobileLayout(state,
            containerItem,
            rectsId,
            size,
            options,
            baseComponentShape,
            tempLayout.layout.rows.length,
            isFooter,
            gridLayout
          )
          tempLayout.options.height += temp.layout.rows[0].options.height
          tempLayout.layout.rows.push(temp.layout.rows[0])
        } else {
          tempLayout = !isWaterFall ? initMobileLayout(state, containerItem, rectsId, size, options, baseComponentShape, 0, isFooter) : initGridMobileLayout(state, containerItem, rectsId, size, options, baseComponentShape, 0, isFooter,
            gridLayout)
          tempLayout.options.isFullPage = tempLayout.layout.rows[0].options.isFullPage
          tempLayout.options.height = tempLayout.layout.rows[0].options.height
          // 处理流式布局相关的信息
          handleWaterFallOptions(tempLayout, firstRow)
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (tempLayout === null) {
      // 是流式布局，但是是只有空栅格,这个时候把栅格也同步过去
      if (isWaterFall && !currRectInLayout.length) {
        const primaryAppLayoutStage = new primaryappStagePageLayoutGenerator(1)
        primaryAppLayoutStage.layout.rows[0].options.waterFlow = true
        primaryAppLayoutStage.layout.rows[0].options.gridLayout = gridLayout
        tempLayout = primaryAppLayoutStage
      } else {
        continue;
      }
    }
    const { height, isFullPage } = tempLayout.options
    tempLayout.options = JSON.parse(JSON.stringify(oldAllRectInLayout[i].options))
    tempLayout.options.height = height
    tempLayout.options.isFullPage = isFullPage
    if (Array.isArray(tempLayout.options.padding)) {
      tempLayout.options.padding[0] /= 2
      tempLayout.options.padding[1] = 0 // appPaddingLeft
      tempLayout.options.padding[2] /= 2
      tempLayout.options.padding[3] = 0 // appPaddingRight
      tempLayout.options.paddingTypeFlag = 2 // 设置为边距分别处理模式
      // tempLayout.id = pageLayoutList.length
    } else if (isNaN(tempLayout.options.padding) === false) {
      tempLayout.options.padding /= 2
    } else if (tempLayout.options.paddingLeft) {
      tempLayout.options.paddingLeft = 0 // appPaddingLeft
      tempLayout.options.paddingRight = 0 // appPaddingRight
      tempLayout.options.paddingTop /= 2
      tempLayout.options.paddingBottom /= 2
    }
    // 保留Pc端的ID,用作局部同步
    // todo 还有问题
    tempLayout.id = oldAllRectInLayout[i].id
    // 通栏宽度判定需求，如果PC是自定义宽度，则同步后移动端通栏变更为充满宽度
    if (_layout?.options?.isCustomWidth) {
      tempLayout.options.isCustomWidth = false
      tempLayout.options.widthType = "%"
      tempLayout.options.width = 100
      tempLayout.options.isFullPage = true
    }
    if (data.type === "new" && pageLayoutList[pageLayoutList.length - 1].options.inDocument === "footer") {
      pageLayoutList.splice(pageLayoutList.length - 1, 0, tempLayout)
    } else {
      if (data.type === "edit" && typeof curIndex !== "undefined" && curIndex !== -1) {
        pageLayoutList.splice(curIndex, 0, tempLayout)
      } else if (
        pageLayoutList.length > 1 &&
        pageLayoutList[pageLayoutList.length - 1].options.inDocument === "footer"
      ) {
        pageLayoutList.splice(pageLayoutList.length - 2, 0, tempLayout)
      } else {
        pageLayoutList.push(tempLayout)
      }
    }
  }
  //新通栏初始化完毕 放到webjson中并通过vue.set保证触发页面更新
  let newPageLayout
  switch (data.type) {
    case "new":
      newPageLayout = state.page.pageLayoutList
      Vue.set(state.page, "pageLayoutList", [])
      //重新渲染页面 触发组件数据更新
      await stop(50)
      Vue.set(state.page, "pageLayoutList", newPageLayout)
      break
    case "edit":
      newPageLayout = state.page.pageLayoutList
      Vue.set(state.page, "pageLayoutList", [])
      //重新渲染页面 触发组件数据更新
      await stop(50)
      Vue.set(state.page, "pageLayoutList", newPageLayout)
      break
    default:
      Vue.set(state.page, "pageLayoutList", [])
      //重新渲染页面 触发组件数据更新
      await stop(50)
      Vue.set(state.page, "pageLayoutList", pageLayoutList)
  }
  Vue.set(state.page, "pageLayoutType", "layOut")
  Vue.set(state.page, "pageLayoutList", pageLayoutList)
  // 等待一秒的dom更新
  await stop(500)
  //更新自由布局和轮播内的组件的大小和位置
  try {
    const t2 = new Date().getTime()
    await updateSwiperAndLayoutComponent(containerItem, allRectInNewLayout, pageLayoutList, headerLayout)
    console.log("layoutTime", (new Date().getTime() - t2) / 1000)
  } catch (error) {
    console.error(error)
  }
  Vue.set(state.page, "pageLayoutList", [])
  //重新渲染页面 触发组件数据更新
  await stop(50)
  Vue.set(state.page, "pageLayoutList", pageLayoutList)
  console.log("end", (new Date().getTime() - t1) / 1000)
  console.log("pageLayoutList", pageLayoutList)
}
// 处理子页面关系
function subPagesRelationHandle(state, data, type) {
  // 找到pc端通栏对应的组件ids
  let newRectIds = findAllRects(data.newPageLayout)
  // 根据rectIds找到对应的组件的appId集合
  let appIds = []
  if (newRectIds.length) {
    data.data.page.children[0].children.forEach(item => {
      if (newRectIds.includes(item.rect_id)) {
        appIds.push(item.options.appId)
      }
    })
  }
  // 根据appId找到对应的子页面关系
  let newSubPages = []
  if (appIds.length && data?.data?.page?.subPages) {
    data.data.page.subPages.forEach(item => {
      if (appIds.includes(item.appId)) {
        newSubPages.push(item)
      }
    })
  }
  let oldSubPages = (state.page && state.page.subPages) || []
  // 判断当前子页面的子页面是否包含在newSubPages关系中
  if (type === "edit") {
    state.page.subPages.forEach(item => {
      if (appIds.includes(item.appId)) {
        // 删除原有的子页面
        oldSubPages.splice(
          oldSubPages.findIndex(it => it.appId === item.appId),
          1
        )
      }
    })
  }
  // 将新的子页面添加到state中
  oldSubPages.push(...newSubPages)
  Vue.set(state.page, "subPages", oldSubPages)
}

function handleWaterFallOptions(handledLayout, prevRow) {
  if (!prevRow?.options?.waterFlow) return
  const defaultMaxRow = 48
  handledLayout.layout.rows[0].options.waterFlow = true
  handledLayout.layout.rows[0].options.gridLayout = (prevRow?.options?.gridLayout || []).map(item => {
    return {...item, w: defaultMaxRow - 2, x: 1}
  })
}

// 移动端自适应 横向标签布局的tab索引标志
function setTabRowStart(oldAllRectInLayout) {
  // 可切换的内容
  let tabBoxRows = oldAllRectInLayout?.layout?.rows[0]?.layout?.rows[1]
  // 有多少个tab 就有多少个row 至少为1
  let rowsItem = tabBoxRows?.layout?.rows
  if (rowsItem?.length) {
    for (let i = 0; i < rowsItem.length; i++) {
      let colsItem = rowsItem[i].layout?.cols
      if (colsItem?.length) {
        // 行下面还有列 查找当前tab下的第一个单元格
        let firstCol = findFirstCol(colsItem[0]) || colsItem[0]
        firstCol.options.tabRowStart = true
      } else {
        rowsItem[i].options.tabRowStart = true
      }
    }
    oldAllRectInLayout.layout.rows[0].layout.rows[0].options.tabRowStart = true
    oldAllRectInLayout.layout.rows[0].layout.rows[1] = tabBoxRows
  }
  return oldAllRectInLayout
}
// 移动端自适应 竖向标签布局的tab索引标志
function setTabColStart(oldAllRectInLayout) {
  // 可切换的内容
  let tabBoxCols = oldAllRectInLayout?.layout?.rows[0]?.layout?.rows[0]?.layout?.cols[1]
  // 有多少个tab 就有多少个row 至少为1
  let colsItem = tabBoxCols?.layout?.cols
  if (colsItem?.length) {
    for (let i = 0; i < colsItem.length; i++) {
      let rowsItem = colsItem[i].layout?.rows
      if (rowsItem?.length) {
        // 列下面还有行 查找当前tab下的第一个单元格
        let firstRow = findFirstCol(rowsItem[0]) || rowsItem[0]
        firstRow.options.tabColStart = true
      } else {
        colsItem[i].options.tabColStart = true
      }
    }
    oldAllRectInLayout.layout.rows[0].layout.rows[0].layout.cols[1] = tabBoxCols
  }
  return oldAllRectInLayout
}
function findFirstCol(col) {
  if (col?.rectIds?.length) {
    return col
  }
  if (col?.layout?.rows?.length) {
    return findFirstCol(col?.layout?.rows[0])
  }
  if (col?.layout?.cols?.length) {
    return findFirstCol(col?.layout?.cols[0])
  }
}

function initGridMobileLayout(state, containerItem, rectsId, layoutSize, layoutOptions, baseComponentShape, id, isFooter, gridLayout) {
  const GRID_HEIGHT = 1
  const primaryAppLayoutStage = new primaryappStagePageLayoutGenerator(1)
  const { boundHeight, boundWidth } = layoutSize
  const { bg, paddingTop, paddingBottom, tabRowStart, tabColStart } = layoutOptions
  const { baseComponent, otherComponent } = classifyComponents(containerItem, rectsId, baseComponentShape)
  primaryAppLayoutStage.layout.rows[0].id = id
  primaryAppLayoutStage.layout.rows[0].options.bg = bg
  primaryAppLayoutStage.layout.rows[0].options.isFullPage = true
  primaryAppLayoutStage.layout.rows[0].options.height = boundHeight
  primaryAppLayoutStage.layout.rows[0].rectIds = [...rectsId]
  primaryAppLayoutStage.layout.rows[0].options.tabRowStart = tabRowStart
  primaryAppLayoutStage.layout.rows[0].options.tabColStart = tabColStart
  primaryAppLayoutStage.layout.rows[0].options.isNewVersion = true
  // 在列表页中，如果存在面包屑组件，并且导航组件显示，初始化一个按钮组件到面包屑组件所在布局中，如果没有导航组件，则不初始化，且隐藏导航组件所在通栏
  if (state.type === "listPage") {
    const breadCrumbsRectId = findComponentRectId(rectsId, containerItem, "cxBreadCrumbs")
    const navMenuRectId = findComponentRectId(rectsId, containerItem, "cxNavMenuVertical")
    const appId = GetRequest().a
    const subPage = JSON.parse(window.localStorage.getItem("subPageSetting-" + appId + "-stage"))
    // 判断breadCrumbsRectId是否存在，该值可能为0
    if (!isNaN(breadCrumbsRectId) && subPage.listPageSetting.showNavMenu) {
      const data = JSON.parse(JSON.stringify(list_page_drawer_button_children[0].attribute))
      const allRects = getAttrById(state, { container_id: containerItem.container_id }, "container").children
      let _rect_id = -1
      if (allRects.length > 0) {
        _rect_id = smartMathMax(
          ...allRects.map(function (o) {
            return o.rect_id
          })
        )
      }
      data.rect_id = _rect_id + 1
      event.mergeEvent(
        {
          options: data.options,
          ids: {
            container_id: containerItem.container_id,
            rect_id: data.rect_id
          }
        },
        "rect"
      )
      getAttrById(state, { container_id: containerItem.container_id }, "container").children.push(data)

      primaryAppLayoutStage.layout.rows[0].rectIds.push(data.rect_id)
    }
    if (navMenuRectId && !subPage.listPageSetting.showNavMenu) {
      // 隐藏导航组件所在通栏
      primaryAppLayoutStage.layout.options.isShow = false
    }
  }
  if (!isFooter) {
    const gap = 15
    const appGridWidth = appContentWidth - 20 - 2
    for(let i = 0; i < gridLayout.length; i++) {
      const gridItem = gridLayout[i]
      // 找到当前栅格下面的基础组件
      const components = baseComponent.filter(item => item.i === gridItem.i)
      if (!components.length) continue
      // 处理宽度
      components.forEach(item => {
        if (['imageComponent', 'cxVideo', 'cxButton', 'cxAudio', 'cxDigitRoll'].includes(item.shape)) {
          (item.options.width >  appGridWidth - gap * 2) && (item.options.width = appGridWidth - gap * 2)
      }})
      const gridHeight =  Math.round(GRID_HEIGHT * gridItem.h)
      // 先按照x排序，再按y排序
      const sortedComponents = components.sort((a,b) => {
        if (a?.options?.left === b?.options?.left) {
          return a?.options?.top === b?.options?.top
        } else {
          return a?.options?.left - b?.options?.left
        }
      })

      let totalHeight = gap
      const totalGridHeight = sortedComponents.reduce((height, item, index) => {
        height = height + (item.options.heightType === '%' ? item.options.height /100 * gridHeight : item.options.height) + gap
        return height
      }, gap)
      const totalH  =  Math.ceil(totalGridHeight / GRID_HEIGHT)
      sortedComponents.forEach(item => {
        item.options.left = sortedComponents.length === 1 ? 0 : gap
        item.options.top = totalHeight
        if (item.options.heightType === '%') {
          item.options.height = item.options.height /100 * gridHeight
          item.options.heightType = "px"
        }
        totalHeight +=  item.options.height + gap
      })
      // 如果累积下来的高度比栅格高了，则调整栅格的y值
      totalH > gridItem.h && (gridItem.h = totalH)
    }
  }
  //普通通栏 进行组件的连通性判断、覆盖检测、x轴y轴的拉开等操作
  if (!isFooter) {

  } else {
    let totalH = 0
    baseComponent.sort((a, b) => a.options.top - b.options.top)
    for (let i = 0; i < baseComponent.length; i++) {
      const ele = baseComponent[i].options
      ele.left = 0
      ele.top = totalH
      totalH += new HandleSize(appContentWidth, boundHeight).getRealSize(ele, "height") + 5
    }
    //底部通栏只需要对组件进行纵向拉开
    primaryAppLayoutStage.layout.rows[0].options.height = totalH
  }

  return primaryAppLayoutStage
}

function initMobileLayout(state, containerItem, rectsId, layoutSize, layoutOptions, baseComponentShape, id, isFooter) {
  const primaryAppLayoutStage = new primaryappStagePageLayoutGenerator(1)
  const { boundHeight, boundWidth } = layoutSize
  const { bg, paddingTop, paddingBottom, tabRowStart, tabColStart } = layoutOptions
  const { baseComponent, otherComponent } = classifyComponents(containerItem, rectsId, baseComponentShape)
  primaryAppLayoutStage.layout.rows[0].id = id
  primaryAppLayoutStage.layout.rows[0].options.bg = bg
  primaryAppLayoutStage.layout.rows[0].options.isFullPage = true
  primaryAppLayoutStage.layout.rows[0].options.height = boundHeight
  primaryAppLayoutStage.layout.rows[0].rectIds = [...rectsId]
  primaryAppLayoutStage.layout.rows[0].options.tabRowStart = tabRowStart
  primaryAppLayoutStage.layout.rows[0].options.tabColStart = tabColStart
  // 在列表页中，如果存在面包屑组件，并且导航组件显示，初始化一个按钮组件到面包屑组件所在布局中，如果没有导航组件，则不初始化，且隐藏导航组件所在通栏
  if (state.type === "listPage") {
    const breadCrumbsRectId = findComponentRectId(rectsId, containerItem, "cxBreadCrumbs")
    const navMenuRectId = findComponentRectId(rectsId, containerItem, "cxNavMenuVertical")
    const appId = GetRequest().a
    const subPage = JSON.parse(window.localStorage.getItem("subPageSetting-" + appId + "-stage"))
    // 判断breadCrumbsRectId是否存在，该值可能为0
    if (!isNaN(breadCrumbsRectId) && subPage.listPageSetting.showNavMenu) {
      const data = JSON.parse(JSON.stringify(list_page_drawer_button_children[0].attribute))
      const allRects = getAttrById(state, { container_id: containerItem.container_id }, "container").children
      let _rect_id = -1
      if (allRects.length > 0) {
        _rect_id = smartMathMax(
          ...allRects.map(function (o) {
            return o.rect_id
          })
        )
      }
      data.rect_id = _rect_id + 1
      event.mergeEvent(
        {
          options: data.options,
          ids: {
            container_id: containerItem.container_id,
            rect_id: data.rect_id
          }
        },
        "rect"
      )
      getAttrById(state, { container_id: containerItem.container_id }, "container").children.push(data)

      primaryAppLayoutStage.layout.rows[0].rectIds.push(data.rect_id)
    }
    if (navMenuRectId && !subPage.listPageSetting.showNavMenu) {
      // 隐藏导航组件所在通栏
      primaryAppLayoutStage.layout.options.isShow = false
    }
  }

  let mergeRelation = null
  if (!isFooter) {
    mergeRelation = new MergeRelation(baseComponent, boundWidth, boundHeight, appContentWidth, boundHeight)
  }
  //根据mergeRelation初始化好的联通关系，对大小位置变化后的组件进行关系还原
  //自适应单元格内部组件基础的left和width
  for (let i = 0; i < baseComponent.length; i++) {
    handleChangeElementInWrapper(baseComponent[i].options, boundWidth, boundHeight, appContentWidth, boundHeight)
  }
  //普通通栏 进行组件的连通性判断、覆盖检测、x轴y轴的拉开等操作
  if (!isFooter) {
    mergeRelation.reMergeElements()
    try {
      resetCoveredComponent({
        component: baseComponent,
        basePath: "options",
        wrapperW: appContentWidth,
        wrapperH: boundHeight,
        mode: "x",
        resize: false
      })
    } catch (error) {
      console.log(error)
    }
    try {
      const newH = resetCoveredComponent({
        component: baseComponent,
        basePath: "options",
        wrapperW: appContentWidth,
        wrapperH: boundHeight,
        mode: "y",
        resize: true
      })
      primaryAppLayoutStage.layout.rows[0].options.height = Math.max(boundHeight, newH)
    } catch (error) {
      console.log(error)
    }
  } else {
    let totalH = 0
    baseComponent.sort((a, b) => a.options.top - b.options.top)
    for (let i = 0; i < baseComponent.length; i++) {
      const ele = baseComponent[i].options
      ele.left = 0
      ele.top = totalH
      totalH += new HandleSize(appContentWidth, boundHeight).getRealSize(ele, "height") + 5
    }
    //底部通栏只需要对组件进行纵向拉开
    primaryAppLayoutStage.layout.rows[0].options.height = totalH
  }

  return primaryAppLayoutStage
}
function GetRequest() {
  var url = location.href //获取url中"?"符后的字串
  var theRequest = new Object()
  if (url.indexOf("?") != -1) {
    var str = url.split("?")[1]
    var strs = str.split("&")
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
    }
  }
  return theRequest
}
/**
 * 获取指定组件组件的rect_id
 * @param {*} rectsId
 * @param {*} containerItem
 * @returns
 */
function findComponentRectId(rectsId, containerItem, type) {
  for (let i = 0; i < rectsId.length; i++) {
    const rect = getRectOpt(containerItem, rectsId[i])
    if (rect.shape === type) {
      return rect.rect_id
    }
  }
}
async function updateSwiperAndLayoutComponent(containerItem, allRectInNewLayout, pageLayoutList, headerLayout) {
  let status = false
  for (let i = 0; i < allRectInNewLayout.length; i++) {
    const { rects: rectsId, size } = allRectInNewLayout[i]
    for (let j = 0; j < rectsId.length; j++) {
      const rect = getRectOpt(containerItem, rectsId[j])
      if (rect === undefined) continue
      if (hadAppModule[rect.rect_id]) continue //有移动端的系统模板的组件 不需要进行单元格计算
      const lowerName = rect.shape.toLowerCase()
      console.log("lowerName :>>", lowerName)
      if (lowerName.includes("layout") && !lowerName.includes("cxpage") && lowerName !== "cxautolayout") { // 自动布局不参与计算
        try {
          handleCalcLayout(rect, size.boundWidth, containerItem, size.boundHeight, pageLayoutList, headerLayout, i)
          status = true
        } catch (error) {
          console.error(error)
        }
      } else if (lowerName.includes("swiper")) {
        try {
          // 轮播自适应固定高度250
          growCurrPageLayoutH(pageLayoutList, rect, 0, 250)
          const path = getRectPath(pageLayoutList, rect.rect_id).split("-")
          const rectEl = {
            isNativeObj: true,
            offsetWidth: appContentWidth,
            offsetHeight: pageLayoutList[path[0]].options.height
          }
          handleFixSwiper(rect, rectEl)
          status = true
        } catch (error) {
          console.error(error)
        }
      } else {
        //递归修改每个配置项内的fontsize
        const keepFontSize = ["cxbutton"]
        !keepFontSize.find(it => it === lowerName) && deepChangeFontSize(rect.options)
      }
    }
  }
  //如果有轮播组件或自由布局组件发生了变化的话 等待两秒 等待发生单元格布局变化的自由布局组件完成自适应
  if (status === true) await stop(2000)
  for (let i = 0; i < allRectInNewLayout.length; i++) {
    const { rects: rectsId, size } = allRectInNewLayout[i]
    for (let j = 0; j < rectsId.length; j++) {
      const rect = getRectOpt(containerItem, rectsId[j])
      if (rect === undefined) continue
      //将组件的ComponentTypeId更新为appmenu对应的ComponentTypeId
      resetComponentTypeId(rect.options, rect.shape)
      if (rect?.shape === "cxPageLayoutComponent") {
        const layoutRects = findAllRects(rect?.options?.layout)
        if (layoutRects?.length) {
          layoutRects.forEach(layoutItemRectId => {
            const _rect = getRectOpt(containerItem, layoutItemRectId)
            _rect && resetComponentTypeId(_rect.options, _rect.shape)
          })
        }
      }
      if (hadAppModule[rect.rect_id]) {
        //有移动端模板的逻辑
        handleMobileModule(rect, size, pageLayoutList)
        continue
      }
      const lowerName = rect.shape.toLowerCase()
      if (lowerName.includes("layout") && !lowerName.includes("cxpage") && lowerName !== "cxautolayout") { // 自动布局不参与计算
        try {
          const [isComplete, colsSize, allColsElement, ItemRow] = getRowInfo(rect, containerItem)
          await setAllElementInLayoutSizeAndFontSize(allColsElement, rect, containerItem, pageLayoutList)
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
}
function resetComponentTypeId(opt, shape) {
  if (opt.hasOwnProperty("componentTypeId") && opt.componentTypeId?.length > 0) {
    let componentName = null
    console.log("menu.menu", menu.menu)
    const menuType = menu.menu.children.find(type => {
      let res = type.children.find(component => component.typeId === opt.componentTypeId || (opt.componentTypeName && component.type === opt.componentTypeName))
      if (res) {
        componentName = res.name
      }
      return res
    })
    console.log("menuType",menuType)
    if (menuType) {
      const typeName = menuType.name
      const tarMenu = appMenu.menu.children.find(it => it.name === typeName)
      if (tarMenu) {
        const newComponent = tarMenu.children.find(coms => coms.name === componentName)
        if (newComponent && newComponent.typeId) {
          opt.componentTypeId = newComponent.typeId
        } else {// 没有应该重置为空 避免保留pc端的id
          opt.componentTypeId = ""
        }
      }
    } else {// 没有应该重置为空
      opt.componentTypeId = ""
    }
  }
  //判断子组件是否是收藏的样式，如果是也需要替换对应的ComponentTypeId
  if (shape === "swiperComponent" || shape === "emptyLayoutComponent" || shape === "cxAutoLayout") {
    resetChildComponentTypeId(opt)
  }
}
function resetChildComponentTypeId(opt) {
  if (opt && typeof opt === "object") {
    for (let k in opt) {
      if (typeof opt[k] === "object") {
        if (k === "elementOptions") {
          opt[k].forEach((item, index) => {
            if (item.options && item.options.componentTypeId) {
              resetComponentTypeId(opt[k][index].options)
            }
            if (!item.options && item.componentTypeId) {
              resetComponentTypeId(opt[k][index])
            }
          })
        }
        resetChildComponentTypeId(opt[k])
      }
    }
  }
}
function handleMobileModule(rect, size, pageLayoutList) {
  const mobileModule = hadAppModule[rect.rect_id]
  delete hadAppModule[rect.rect_id]
  copyDataId(rect.options, mobileModule.options)
  // 将pc端的动画同步到移动端
  mobileModule.options.hoverAnimates = rect.options.hoverAnimates
  mobileModule.options.clickAnimates = rect.options.clickAnimates
  mobileModule.options.pageloadAnimates = rect.options.pageloadAnimates

  if (rect.options.restDataUrl) {
    mobileModule.options.restDataUrl = rect.options.restDataUrl
  }
  if (rect.options.myFetchParam) {
    mobileModule.options.myFetchParam = rect.options.myFetchParam
  }
  // 同步pc端的应用名
  if (rect.options.name) {
    mobileModule.options.name = rect.options.name
  }
  const growH = mobileModule.options.height - size.boundHeight
  growCurrPageLayoutH(pageLayoutList, rect, growH)
  Vue.set(rect, "options", mobileModule.options)
}
function getRowInfo(rect, containerItem) {
  const useActiveIndex = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
  const ItemRow = rect.options.rows[useActiveIndex]
  return [...checkLayoutColSize(ItemRow, rect, containerItem), ItemRow]
}
function handleCalcLayout(rect, oldRectW, containerItem, oldRectH, pageLayoutList, headerLayout, pageLayoutListIndex) {
  if (rect.options.hasOwnProperty("padding")) {
    const { padding, paddingTop, paddingRight, paddingBottom, paddingLeft } = rect.options
    oldRectH -= paddingTop === undefined ? padding * 2 : paddingTop + paddingBottom
    oldRectW -= paddingLeft === undefined ? padding * 2 : paddingLeft + paddingRight
  }
  let newRectHeight = 0
  let rectContentH = oldRectH
  rect.options.titleOptions.forEach(item => {
    if ((item.type === "top" || item.type === "bottom") && item.isShow !== false) rectContentH -= item.height || 0
  })
  const top = rect.options.titleOptions.find(it => it.type === "top")
  const right = rect.options.titleOptions.find(it => it.type === "right")
  const bottom = rect.options.titleOptions.find(it => it.type === "bottom")
  const left = rect.options.titleOptions.find(it => it.type === "left")
  const _ = (o, type) => (o.hasOwnProperty(type) ? o[type] : 80)
  const LRH = oldRectH - _(top, "height") - _(bottom, "height")
  const elements = o => (o.isShow ? o.elementOptions.filter(it => it.isShow !== false) : [])
  const mergeReT = new MergeRelation(elements(top), oldRectW, _(top, "height"), appContentWidth, _(top, "height"))
  const mergeReR = new MergeRelation(elements(right), _(right, "width"), LRH, appContentWidth, LRH)
  const mergeReB = new MergeRelation(
    elements(bottom),
    oldRectW,
    _(bottom, "height"),
    appContentWidth,
    _(bottom, "height")
  )
  const mergeReL = new MergeRelation(elements(left), _(right, "width"), LRH, appContentWidth, LRH)
  //根据mergeRelation初始化好的联通关系，对大小位置变化后的组件进行关系还原
  //处理左右框的抽屉化，需要放在setOtherContentSize之前
  //因为需要等待两个handleTitleOptions进行组件新增后再进行按钮新增

  handleTitleOptions(rect, oldRectW, "L")
  handleTitleOptions(rect, oldRectW, "R")
  //处理自由布局左右四边框的抽屉化
  setOtherContentSize(rect, oldRectW, oldRectH, {
    top: mergeReT,
    right: mergeReR,
    bottom: mergeReB,
    left: mergeReL
  }) //回显自由布局赏析左右的边框内的内容 如分页等
  //处理头部框组件挤占的问题，需要放在两个handleTitleOptions之后，因为需要等待两个handleTitleOptions进行组件新增
  handleTopOptions(rect, growCurrPageLayoutH.bind(this, pageLayoutList, rect))

  const [isComplete, colsSize, allColsElement, ItemRow] = getRowInfo(rect, containerItem)
  //检查是否是规整布局 非规整布局就跳过，规整布局是指：自由布局组件的每一个单元格的大小一致的情况
  //将自由布局的每个单元格内的组件的大小都改为百分号,且递归的修改自由布局内单元格中的组件的fontsize
  let colsSizeKinds = null
  let colsSizeKindsKeys = 0
  if (!isComplete) {
    colsSizeKinds = kindOfColSize(colsSize)
    colsSizeKindsKeys = Object.keys(colsSizeKinds)
  }
  //规整布局 每个单元格大小一致
  if (isComplete) {
    //检查单行单列布局
    const contentRow = deepCheckSingleLayout(ItemRow)
    //检查是否为一行一列的自由布局,且每行的列数一致， 一行一列的自由布局不需要变化
    const needFix = checkRowSize(contentRow)
    if (needFix) {
      calcLayout(contentRow, oldRectW, rectContentH)
    }
  } else if (colsSizeKindsKeys.length == 2) {
    //判断单元格大小类型是否等于2种
    //只有一格不做判断
    const tempHeight = handleTwoKindsCols(colsSizeKinds, colsSizeKindsKeys, ItemRow)
    newRectHeight = Math.max(newRectHeight, tempHeight)
  } else if (colsSizeKindsKeys.length > 2) {
    //判断单元格大小类型是否大于2种
    const tempHeight = handleThreeKindsCols(colsSizeKinds, colsSizeKindsKeys, ItemRow)
    newRectHeight = Math.max(newRectHeight, tempHeight)
  }
  let titleOptionsTotalH = 0
  rect.options.titleOptions?.forEach(item => {
    if ((item.type === "top" || item.type === "bottom") && item.isShow === true) titleOptionsTotalH += item.height || 0
  })
  const oldH = rect.options.height
  rect.options.height = Math.max(rect.options.height, titleOptionsTotalH + newRectHeight)
  //由于顶部栏高度发生了改变 需要重新计算父容器高度 做撑高操作
  growCurrPageLayoutH(pageLayoutList, rect, rect.options.height - oldH)
  // }
}
function classifyComponents(containerItem, rectsId, baseComponentShape) {
  const baseComponent = [],
    otherComponent = []
  for (let i = 0; i < rectsId.length; i++) {
    const rect = getRectOpt(containerItem, rectsId[i])
    if (rect === undefined) continue
    if (baseComponentShape.find(it => it === rect.shape)) baseComponent.push(rect)
    else otherComponent.push(rect)
  }
  return { baseComponent, otherComponent }
}
async function setSwiperAndLayoutPercentNumber(rect, lowerInnerElement, size, containerItem, isNewLayout) {
  const { widthType, heightType } = rect.options
  let status = false
  //首先把组件的宽高还原为px,便于后续计算内部组件的百分比宽高位置
  if (widthType === "%" || isNewLayout) {
    status = true
    Vue.set(rect.options, "width", size.boundWidth)
    Vue.set(rect.options, "widthType", "px")
  }
  if (heightType === "%" || isNewLayout) {
    status = true
    Vue.set(rect.options, "height", size.boundHeight)
    Vue.set(rect.options, "heightType", "px")
  }
  //status为true,证明宽高任一为百分比，此时需要等待发证变化后的dom渲染完成
  if (status) {
    await stop(50)
  }
  //轮播组件和自由布局组件需要对里面的组件在当前单元格或者轮播页中的行大小和位置的百分比设置
  if (lowerInnerElement.includes("swiper")) {
    //轮播组件
    const rectEl = { isNativeObj: true, offsetHeight: size.boundHeight, offsetWidth: size.boundWidth }
    setSwiperPercentPosition(rect, rectEl)
  } else if (lowerInnerElement.includes("layout") && !lowerInnerElement.includes("cxpage") ) {
    //自由布局组件由于有行列嵌套，且行列有内外边距，所以只能在此处进行百分比设置，在变小后再进行等比例变小
    await setLayoutPercentPosition(rect, size.boundWidth, size.boundHeight, containerItem)
  }
}
async function loading() {
  let loadingInstance = Loading.service({
    target: document.getElementById("editPage"),
    lock: true,
    text: "自适应处理中",
    spinner: "loadingLottieWrapper",
    customClass: "autoLayoutLoadingWrapper",
    background: "white"
  })
  let lottieWrapper = document.getElementsByClassName("loadingLottieWrapper")[0]
  document.getElementsByClassName("el-loading-text")[0].style.color = "rgba(0, 0, 0, 0.8)"
  lottieWrapper.style.width = "84px"
  lottieWrapper.style.height = "84px"
  lottieWrapper.style.display = "block"
  lottieWrapper.style.margin = "0 auto"
  let lottieInstance = lottie.loadAnimation({
    container: document.getElementsByClassName("loadingLottieWrapper")[0],
    renderer: "svg", // 渲染方式:svg：支持交互、不会失帧、canvas、html：支持3D，支持交互
    loop: true,
    animationData: autoLayoutLoading
  })
  document.getElementsByClassName("el-loading-spinner")[0].style.top = "40%"
  await stop(200)
  return Promise.resolve(function () {
    loadingInstance.close && loadingInstance.close()
    lottieInstance.destroy && lottieInstance.destroy()
    loadingInstance = null
    lottieInstance = null
    lottieWrapper = null
  })
}
async function asyncChangeComponent(state, data) {
  /**
   * 组件的loading动画,当返回值为function时,执行该函数用于关闭动画
   */
  const loadingStopCb = process.env.VUE_APP_MODE === "prod" ? await loading() : null
  if (data.data.page.isPcSyncApp) {
    state.page.isPcSyncApp = data.data.page.isPcSyncApp
  }
  if (data.data.type) {
    state.type = data.data.type
  }
  // 整体同步的时候 将所有组件添加到移动端
  if (!data.type) {
    state.page.children = data.data.page.children
  }
  localStorage.setItem("asyncChangeComponent", 1)
  try {
    const baseComponentShape = getBaseComponentShape()
    if (data.data.page.pageLayoutType === "layOut") {
      await newLayoutAutoSize(state, data, baseComponentShape)
    }
    // 局部同步完成之后的回调
    if (data.type) {
      Message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "success",
        message: "同步完成"
      })
    }
  } catch (error) {
    console.log(error)
  }
  console.log("state", state)
  localStorage.removeItem("asyncChangeComponent")
  loadingStopCb && loadingStopCb()
}
async function stop(time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

function handleMultiFilterLayout(state, containerItem, rect) {
  const primaryAppLayoutStage = new primaryappStagePageLayoutGenerator(1)
  primaryAppLayoutStage.layout.rows[0].id = 0
  primaryAppLayoutStage.layout.rows[0].options.isFullPage = true
  primaryAppLayoutStage.layout.rows[0].options.height = 60
  const data = JSON.parse(JSON.stringify(app_multiFilter_drawer_button_children[0].attribute))
  const allRects = getAttrById(state, { container_id: containerItem.container_id }, "container").children
  let _rect_id = -1
  if (allRects.length > 0) {
    _rect_id = smartMathMax(
      ...allRects.map(function (o) {
        return o.rect_id
      })
    )
  }
  data.rect_id = _rect_id + 1
  event.mergeEvent(
    {
      options: data.options,
      ids: {
        container_id: containerItem.container_id,
        rect_id: data.rect_id
      }
    },
    "rect"
  )
  getAttrById(state, { container_id: containerItem.container_id }, "container").children.push(data)
  primaryAppLayoutStage.layout.rows[0].rectIds.push(data.rect_id)
  console.log("primaryAppLayoutStage", primaryAppLayoutStage)
  return primaryAppLayoutStage
}
// 获取该通栏下的所有组件id
function getAllRects(layout) {
  let curLayout = layout
  if (layout.rectIds && layout.rectIds.length > 0) {
    allRectsOfPagelayout = allRectsOfPagelayout.concat(layout.rectIds)
  }
  curLayout.layout.rows.forEach(item => {
    return getAllRects(item)
  })
  curLayout.layout.cols?.forEach(item => {
    return getAllRects(item)
  })
}
// 替换该通栏下的所有组件id
function headerReplaceRectIds(rectIdRelation, headerLayout, state, data) {
  let headComponentMap = headerLayout.options.headComponentMap || {}
  for (let key in rectIdRelation) {
    let newRectId = rectIdRelation[key]
    for (let headerKey in headComponentMap) {
      if (newRectId === headComponentMap[headerKey]) {
        const newRect = findRectPath(data.data.page.children, headerKey, newRectId, true)
        if (newRect) {
          state.page.children[0].children.push(newRect)
        }
        break
      }
    }
  }
  for (let headerKey in headComponentMap) {
    if (rectIdRelation.hasOwnProperty(headComponentMap[headerKey])) {
      headComponentMap[headerKey] = rectIdRelation[headComponentMap[headerKey]]
    }
  }
  replaceHeaderLayoutRectIds(rectIdRelation, headerLayout)
}
// 获取该通栏下的所有组件id
function replaceHeaderLayoutRectIds(rectIdRelation, layout) {
  let curLayout = layout
  if (layout.rectIds && layout.rectIds.length > 0) {
    layout.rectIds.forEach((item, index) => {
      layout.rectIds[index] = rectIdRelation[item]
    })
  }
  curLayout.layout.rows.forEach(item => {
    if (item.rectIds && item.rectIds.length > 0) {
      item.rectIds.forEach((childItem, index) => {
        item.rectIds[index] = rectIdRelation[childItem]
      })
    } else {
      replaceHeaderLayoutRectIds(rectIdRelation, item)
    }
  })
  curLayout.layout.cols?.forEach(item => {
    if (item.rectIds && item.rectIds.length > 0) {
      item.rectIds.forEach((childItem, index) => {
        item.rectIds[index] = rectIdRelation[childItem]
      })
    } else {
      replaceHeaderLayoutRectIds(rectIdRelation, item)
    }
  })
}
function deleteOldRect(curLayout, state) {
  if (curLayout.rectIds && curLayout.rectIds.length > 0) {
    curLayout.rectIds.forEach((rectId, index) => {
      let oldRectIndex = state.page.children[0].children.findIndex(rectItem => rectItem.rect_id === rectId)
      if (oldRectIndex !== -1) {
        state.page.children[0].children.splice(oldRectIndex, 1)
      }
    })
  }
  curLayout.layout.rows.forEach(item => {
    if (item.rectIds && item.rectIds.length > 0) {
      item.rectIds.forEach((rectId, index) => {
        let oldRectIndex = state.page.children[0].children.findIndex(rectItem => rectItem.rect_id === rectId)
        if (oldRectIndex !== -1) {
          state.page.children[0].children.splice(oldRectIndex, 1)
        }
      })
    } else {
      deleteOldRect(item, state)
    }
  })
  curLayout.layout.cols?.forEach(item => {
    if (item.rectIds && item.rectIds.length > 0) {
      item.rectIds.forEach((rectId, index) => {
        let oldRectIndex = state.page.children[0].children.findIndex(rectItem => rectItem.rect_id === rectId)
        if (oldRectIndex !== -1) {
          state.page.children[0].children.splice(oldRectIndex, 1)
        }
      })
    } else {
      deleteOldRect(item, state)
    }
  })
}
// 局部同步，处理之前的rectId
function replaceRectIds(state, allRectInNewLayout, data) {
  let containerId = 0,
    newRectIds = []
  if (data.type === "edit") {
    // 先删除对应通栏内的所有组件
    let isHeader = data.newPageLayout.options.inDocument === "header"
    let appHeader =
      isHeader && state.page.pageLayoutList[0].options.inDocument === "header" ? state.page.pageLayoutList[0] : null
    let relatedLayout = isHeader ? appHeader : state.page.pageLayoutList.find(item => item.id === data.newPageLayout.id)
    if (relatedLayout) {
      allRectsOfPagelayout = []
      getAllRects(relatedLayout)
      let allRectId = state.page.children[containerId].children
      console.log("allRectsOfPagelayout", allRectsOfPagelayout)
      allRectsOfPagelayout.forEach(rectId => {
        let index = allRectId.findIndex(rectItem => rectItem.rect_id === rectId)
        if (index !== -1) {
          // 删除组件的时候，删除对应的动画关系
          // 此处未做删除事件的操作，2.0不计划使用事件
          delAnimateInRect(
            state,
            {
              container_id: containerId,
              rect_id: rectId
            },
            allRectId[index]
          )
          allRectId.splice(index, 1)
        }
      })
    }
  }
  const allRects = state.page.children[containerId].children
  let _rect_id = -1
  if (allRects.length > 0) {
    _rect_id = smartMathMax(
      ...allRects.map(function (o) {
        return o.rect_id
      })
    )
  }
  let rectIdRelation = {}
  let new_rect_id = _rect_id + 1
  allRectInNewLayout.forEach(rectInNewLayout => {
    rectInNewLayout.rects.forEach((rect, index) => {
      let rectComponent = getAttrById(data.data, { container_id: containerId, rect_id: rect }, "rect")
      rectComponent = JSON.parse(JSON.stringify(rectComponent))
      newRectIds.push({
        oldRectId: rect,
        newRectId: new_rect_id
      })
      rectIdRelation[rect] = new_rect_id
      rectInNewLayout.rects[index] = new_rect_id
      // 将先的组件加到移动端
      rectComponent.rect_id = new_rect_id
      getAttrById(state, { container_id: containerId }, "container").children.push(rectComponent)
      new_rect_id = new_rect_id + 1
    })
  })
  //修改对应的动画
  //所有的组件都替换到最新的rectId 之后，重新梳理动画关系
  editAnimateAddLayout(state, newRectIds, containerId)
  return { allRectInNewLayout, rectIdRelation }
}
export default {
  ...publicMutations.call(this, allTypes),
  // 同步stage的webjson
  [allTypes.INIT_DATA](state, data) {
    // state.treeData = data.treeData
    asyncChangeComponent(state, data)
  }
}
